import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIRoutes } from '../global-misc/api-routes';
import { firstValueFrom } from 'rxjs';
import { VisitModel, CreateVisitModel, UpdateVisitModel } from '../global-data-models/visit.model';

@Injectable({ providedIn: 'root' })
export class VisitService {
  constructor(private http: HttpClient) { }

  async getPatientVisits(orgId: string, patientId: string): Promise<VisitModel[]> {
    const apiRoute = APIRoutes.PATIENT_VISIT_ROUTE.replace(':patientId', patientId).replace(':orgId', orgId);
    return await firstValueFrom(this.http.get<VisitModel[]>(apiRoute));
  }

  async getPatientVisit(orgId: string, patientId: string, visitId: string): Promise<VisitModel> {
    const apiRoute = APIRoutes.PATIENT_SINGLE_VISIT_ROUTE.replace(':patientId', patientId).replace(':orgId', orgId).replace(":visitId", visitId);
    return await firstValueFrom(this.http.get<VisitModel>(apiRoute));
  }

  async createPatientVisit(orgId: string, patientId: string, visit: CreateVisitModel): Promise<VisitModel> {
    const apiRoute = APIRoutes.PATIENT_VISIT_ROUTE.replace(":patientId", patientId).replace(':orgId', orgId);
    return await firstValueFrom(this.http.post<any>(apiRoute, visit));
  }

  async updatePatientVisit(orgId: string, patientId: string, visitId: string, visit: UpdateVisitModel): Promise<VisitModel> {
    const apiRoute = APIRoutes.PATIENT_SINGLE_VISIT_ROUTE.replace(":patientId", patientId).replace(':orgId', orgId).replace(":visitId", visitId);
    return await firstValueFrom(this.http.patch<VisitModel>(apiRoute, visit));
  }

  async deletePatientVisit(orgId: string, patientId: string, visitId: string): Promise<VisitModel> {
    const apiRoute = APIRoutes.PATIENT_SINGLE_VISIT_ROUTE.replace(":patientId", patientId).replace(':orgId', orgId).replace(":visitId", visitId);
    return await firstValueFrom(this.http.delete<VisitModel>(apiRoute));
  }
}
